// extracted by mini-css-extract-plugin
export default {"NewLibraryAdminDialog":"NewLibraryAdminDialog_NewLibraryAdminDialog__6EybC"};